<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="bg-transparent p-0 mb-3">
      <h6 class="offcanvas-header-text text-start" *ngIf="showType !== 'image' && showType !== 'video'">Value</h6>
    </div>
    <form [formGroup]="form">
      <div
        *ngIf="
          showType == 'date' &&
          button &&
          button.button_picker &&
          button.button_picker.format
        "
        class="mb-3"
      >
        <input
          class="form-control input-lg offcanvas-primary border-0"
          [placeholder]="'GENERALS.SELECTDATE' | translate"
          name="dp"
          bsDatepicker
          placement="top"
          [bsConfig]="{
            isAnimated: true,
            adaptivePosition: true,
            showWeekNumbers: false,
            dateInputFormat: button.button_picker.format.toUpperCase(),
            container: 'body'
          }"
          type="text"
          [minDate]="minDate"
          [maxDate]="maxDate"
          formControlName="value"
        />
      </div>
      <div
        *ngIf="
          showType == 'date_range' &&
          button &&
          button.button_picker &&
          button.button_picker.format
        "
        class="mb-3"
      >
        <input
          class="form-control input-lg offcanvas-primary border-0"
          [placeholder]="'GENERALS.SELECTDATE' | translate"
          name="dp"
          bsDaterangepicker
          placement="top"
          [bsConfig]="{
            isAnimated: true,
            adaptivePosition: true,
            showWeekNumbers: false,
            rangeInputFormat: button.button_picker.format.toUpperCase(),
            container: 'body'
          }"
          [minDate]="minDate"
          [maxDate]="maxDate"
          formControlName="value"
        />
      </div>
      <div *ngIf="showType == 'time'" class="mb-3">
        <div
          class="form-control input-lg offcanvas-primary border-0 text-start position-relative"
          (click)="timepicker.open()"
        >
          <ng-container *ngIf="form?.get('value')?.value">
            {{
              form?.get("value")?.value
                | date : (timeFormate ? "hh:mm a" : "HH:mm")
            }}
          </ng-container>
          <ng-container *ngIf="!form?.get('value')?.value">
            {{ timeFormate ? "hh:mm a" : "HH:mm" }}
          </ng-container>

          <input
            [matTimepicker]="timepicker"
            type="text"
            id="text-color"
            class="form-control input-lg offcanvas-primary border-0 position-absolute top-0 start-0 end-0 z"
            formControlName="value"
            (timeChange)="addEvent('change', $event)"
            readonly
            style="z-index: -1"
          />
        </div>
        <!-- <mat-timepicker-toggle matSuffix [for]="timepicker"></mat-timepicker-toggle> -->
        <mat-timepicker
          #timepicker
          [mode]="timePikermode === '01' ? 'dial' : 'input'"
          color="primary"
          [format]="timeFormate ? '12h' : '24h'"
        >
        </mat-timepicker>
      </div>
      <div *ngIf="showType == 'location'" class="mb-3">
        <div class="mb-3">
          <input
            type="text"
            class="form-control input-lg offcanvas-primary border-0"
            (keydown.enter)="$event.preventDefault()"
            placeholder="Search Location"
            [value]="address"
            [id]="'search' + mapId"
            [ngClass]="{ 'is-invalid': submitted && errors }"
            #search
          />
        </div>
        <google-map
          #myGoogleMap
          height="200px"
          width="100%"
          [zoom]="zoom"
          [center]="center"
          [options]="options"
          (mapClick)="mapClicked($event)"
        >
          <map-marker [position]="center"></map-marker>
        </google-map>
      </div>
      <div *ngIf="showType == 'single_slider'" class="mb-3">
        <!-- <ngx-slider
          [value]="form?.get('value')?.value"
          [options]="visibleBarOptions"
          (valueChange)="valueChange($event)"
        ></ngx-slider> -->
        <md-slider
          class="w-100"
          labeled
          [ticks]="showTicks"
          [step]="step"
          [min]="min"
          [max]="max"
          [value]="form?.get('value')?.value"
          (change)="valueChange($event)"
        ></md-slider>
      </div>
      <div *ngIf="showType == 'range_slider'" class="mb-3 row">
        <!-- <ngx-slider
          [(value)]="min"
          [(highValue)]="max"
          [options]="rangeOptions"
          (valueChange)="valueRangeChange($event)"
        ></ngx-slider> -->
        <md-slider
          #slider
          class="w-100"
          labeled
          range
          [min]="rangeStart"
          [max]="rangeEnd"
          [value-start]="min"
          [value-end]="max"
          (change)="onSliderInput($event, slider)"
        ></md-slider>
      </div>
      <div *ngIf="showType == 'others'" class="mb-3">
        <input
          [type]="inputType"
          id="text-color"
          class="form-control input-lg offcanvas-primary border-0"
          formControlName="value"
          (change)="saveChanges()"
        />
      </div>
      <div *ngIf="showType == 'image'" class="mb-3">
        <app-image-uploader
          [data]="imageConfig"
          [bg]="bgimage"
          (images)="buttonImage($event)"
        ></app-image-uploader>
      </div>
      <div *ngIf="showType == 'video'" class="mb-3">
        <app-image-uploader
          [data]="imageConfig"
          [bg]="bgimage"
          (images)="buttonVideo($event)"
        ></app-image-uploader>
      </div>
    </form>
  </div>
</div>
